import React, { useState, useCallback, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { add, format, parseISO } from "date-fns";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import {
  Button,
  Chip,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Table,
  TableHead,
  Paper,
  Tooltip,
  Typography,
  CircularProgress,
  Box,
  Card,
  CardContent,
} from "@material-ui/core";
import {
  Edit,
  CheckCircle,
  SignalCellularConnectedNoInternet2Bar,
  SignalCellularConnectedNoInternet0Bar,
  SignalCellular4Bar,
  CropFree,
  DeleteOutline,
  Facebook,
  Instagram,
  WhatsApp,
} from "@material-ui/icons";

import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import TableRowSkeleton from "../../components/TableRowSkeleton";

import api from "../../services/api";
import WhatsAppModal from "../../components/WhatsAppModal";
import MetaCloudModal from "../../components/MetaCloudModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import QrcodeModal from "../../components/QrcodeModal";
import ConnectionOverviewCard from "../../components/ConnectionOverviewCard";
import ConnectionMethodCards from "../../components/ConnectionMethodCards";
import { i18n } from "../../translate/i18n";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import toastError from "../../errors/toastError";
import formatSerializedId from "../../utils/formatSerializedId";
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ForbiddenPage from "../../components/ForbiddenPage";
import { Can } from "../../components/Can";

const useStyles = makeStyles((theme) => ({
  pageRoot: {
    display: "flex", flexDirection: "column", position: "relative",
    flex: 1, width: "100%", maxWidth: "100%",
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(5),
    height: "calc(100% - 48px)",
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    gap: theme.spacing(1.5),
    background: theme.palette.type === "dark"
      ? "linear-gradient(145deg, #060D1A 0%, #0A1628 100%)"
      : "linear-gradient(145deg, #EBF3FF 0%, #F0F6FF 100%)",
    [theme.breakpoints.down("sm")]: { padding: theme.spacing(1) },
  },
  pageHeader: {
    flexShrink: 0, borderRadius: 16, padding: theme.spacing(1.5, 2.5),
    background: theme.palette.type === "dark"
      ? "linear-gradient(135deg, #0A1628 0%, #0D1F3C 100%)"
      : "linear-gradient(135deg, #EBF3FF 0%, #D6E9FF 100%)",
    border: theme.palette.type === "dark"
      ? "1px solid rgba(0,140,255,0.18)" : "1px solid rgba(0,102,255,0.12)",
    boxShadow: "0 4px 16px rgba(0,102,255,0.07)",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    gap: theme.spacing(2), position: "relative", overflow: "hidden",
  },
  heroBg: {
    position: "absolute", right: -20, top: -20, width: 140, height: 140,
    borderRadius: "50%", pointerEvents: "none",
    background: "radial-gradient(circle, rgba(0,102,255,0.07) 0%, transparent 70%)",
  },
  heroLeft: { display: "flex", alignItems: "center", gap: theme.spacing(1.5), zIndex: 1 },
  heroIcon: {
    width: 48, height: 48, borderRadius: 14, flexShrink: 0, fontSize: "1.4rem",
    background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
    display: "flex", alignItems: "center", justifyContent: "center",
    boxShadow: "0 6px 16px rgba(37,211,102,0.3)",
  },
  heroTitle: { fontWeight: 800, fontSize: "1.1rem", color: theme.palette.type === "dark" ? "#fff" : "#0A1628", letterSpacing: "-0.3px" },
  heroSub: { fontSize: "0.75rem", color: theme.palette.type === "dark" ? "rgba(255,255,255,0.5)" : "rgba(10,22,40,0.55)", marginTop: 2 },
  heroRight: { display: "flex", alignItems: "center", gap: theme.spacing(1.5), zIndex: 1 },
  headerChip: {
    background: theme.palette.type === "dark" ? "rgba(255,255,255,0.07)" : "rgba(255,255,255,0.9)",
    border: "1px solid rgba(37,211,102,0.25)", borderRadius: 10,
    fontWeight: 700, fontSize: "0.72rem",
    color: theme.palette.type === "dark" ? "rgba(255,255,255,0.7)" : "#0A1628",
  },
  controlsPaper: {
    flexShrink: 0, borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1.25),
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  },
  actionButton: {
    minHeight: 38, borderRadius: 10, fontWeight: 700, fontSize: "0.78rem",
    padding: theme.spacing(0.7, 1.8), textTransform: "none",
    boxShadow: "0 4px 12px rgba(0,102,255,0.2)",
  },
  addWaBtn: {
    borderRadius: 12, fontWeight: 700, fontSize: "0.82rem", textTransform: "none",
    background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
    color: "#fff", padding: theme.spacing(0.9, 2.5),
    boxShadow: "0 4px 14px rgba(37,211,102,0.3)",
    "&:hover": { background: "linear-gradient(135deg, #1ebe5b 0%, #0e7a6e 100%)" },
  },
  controlsActions: {
    display: "flex", flexWrap: "wrap", gap: theme.spacing(1), alignItems: "center",
  },
  mainPaper: {
    flex: "0 0 auto",
    minWidth: 0,
    overflowY: "visible",
    overflowX: "auto",
    ...theme.scrollbarStyles,
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 12px 26px rgba(17,24,39,.09)",

    [theme.breakpoints.down("sm")]: {
      overflowX: "hidden",
      borderRadius: 16,
      background: "transparent",
      border: 0,
      boxShadow: "none"
    }
  },
  customTableCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: theme.typography.pxToRem(14),
    border: "1px solid #dadde9",
    maxWidth: 450,
  },
  tooltipPopper: {
    textAlign: "center",
  },
  buttonProgress: {
    color: green[500],
  },
  tableHeaderCell: {
    fontWeight: 700,
    color: theme.palette.text.secondary,
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.04)"
        : "rgba(15, 23, 42, 0.03)",
    fontSize: "0.76rem",
  },
  tableCellText: {
    fontSize: "0.78rem",
  },
  actionIconButton: {
    border: `1px solid ${theme.palette.divider}`,
    margin: theme.spacing(0, 0.2),
  },
  desktopConnectionsTable: {
    display: "block",
    width: "100%",

    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },

  mobileConnectionsList: {
    display: "none",

    [theme.breakpoints.down("sm")]: {
      display: "flex",
      width: "100%",
      boxSizing: "border-box",
      padding: theme.spacing(1),
      flexDirection: "column",
      gap: theme.spacing(1)
    }
  },

  connectionMobileCard: {
    width: "100%",
    boxSizing: "border-box",
    padding: theme.spacing(1.4),
    borderRadius: 16,
    background:
      theme.palette.type === "dark"
        ? "rgba(15,23,42,.94)"
        : "#FFFFFF",
    border: `1px solid ${theme.palette.divider}`,
    boxShadow:
      theme.palette.type === "dark"
        ? "0 10px 26px rgba(0,0,0,.24)"
        : "0 8px 22px rgba(15,23,42,.055)"
  },

  connectionMobileHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.1),
    minWidth: 0
  },

  connectionChannelIcon: {
    width: 44,
    height: 44,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 13,
    background:
      theme.palette.type === "dark"
        ? "rgba(255,255,255,.05)"
        : "#F8FAFC",
    border: `1px solid ${theme.palette.divider}`,

    "& svg": {
      fontSize: 24
    }
  },

  connectionIdentity: {
    flex: 1,
    minWidth: 0
  },

  connectionMobileName: {
    color: theme.palette.text.primary,
    fontSize: ".92rem",
    fontWeight: 850,
    lineHeight: 1.25,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },

  connectionMobileNumber: {
    marginTop: 3,
    color: theme.palette.text.secondary,
    fontSize: ".72rem",
    lineHeight: 1.3
  },

  defaultBadge: {
    flexShrink: 0,
    width: 30,
    height: 30,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(34,197,94,.09)",
    border: "1px solid rgba(34,197,94,.18)",

    "& svg": {
      fontSize: 18,
      color: "#16A34A"
    }
  },

  connectionMobileMeta: {
    marginTop: theme.spacing(1.2),
    display: "grid",
    gridTemplateColumns: "repeat(2,minmax(0,1fr))",
    gap: theme.spacing(.7)
  },

  connectionMetaBox: {
    minWidth: 0,
    padding: "9px 10px",
    borderRadius: 11,
    background:
      theme.palette.type === "dark"
        ? "rgba(255,255,255,.035)"
        : "#F8FAFC",
    border: `1px solid ${theme.palette.divider}`
  },

  connectionMetaLabel: {
    color: theme.palette.text.secondary,
    fontSize: ".58rem",
    fontWeight: 800,
    letterSpacing: ".04em",
    textTransform: "uppercase"
  },

  connectionMetaValue: {
    marginTop: 5,
    color: theme.palette.text.primary,
    fontSize: ".72rem",
    fontWeight: 700,
    lineHeight: 1.35,
    minWidth: 0,
    overflow: "hidden"
  },

  connectionMobileSession: {
    marginTop: theme.spacing(1.1),
    paddingTop: theme.spacing(1.1),
    borderTop: `1px solid ${theme.palette.divider}`
  },

  connectionMobileFooter: {
    marginTop: theme.spacing(1.1),
    paddingTop: theme.spacing(1.1),
    borderTop: `1px solid ${theme.palette.divider}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1)
  },

  connectionUpdatedAt: {
    color: theme.palette.text.secondary,
    fontSize: ".64rem",
    fontWeight: 650
  },

  connectionCardActions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(.6)
  },

  connectionCardAction: {
    width: 34,
    height: 34,
    padding: 0,
    borderRadius: 10,
    border: `1px solid ${theme.palette.divider}`,

    "& svg": {
      fontSize: 18
    }
  },

  editConnectionAction: {
    color: "#0066FF"
  },

  deleteConnectionAction: {
    color: "#EF4444"
  },

  emptyConnectionsMobile: {
    padding: theme.spacing(4, 2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: ".8rem"
  },

  statusCard: {
    margin: "0 auto 12px",
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.08)",
    maxWidth: 640,
    width: "100%",
  },
  statusCardContent: {
    padding: theme.spacing(1.5, 2),
  },
  statusTitle: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#1e2a44",
    textAlign: "center",
  },
  statusText: {
    fontSize: "0.8rem",
  },
}));

function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="determinate" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="textSecondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

const CustomToolTip = ({ title, content, children }) => {
  const classes = useStyles();

  return (
    <Tooltip
      arrow
      classes={{
        tooltip: classes.tooltip,
        popper: classes.tooltipPopper,
      }}
      title={
        <React.Fragment>
          <Typography gutterBottom color="inherit">
            {title}
          </Typography>
          {content && <Typography>{content}</Typography>}
        </React.Fragment>
      }
    >
      {children}
    </Tooltip>
  );
};

const IconChannel = (channel) => {
  switch (channel) {
    case "facebook":
      return <Facebook style={{ color: "#3b5998" }} />;
    case "instagram":
      return <Instagram style={{ color: "#e1306c" }} />;
    case "whatsapp":
      return <WhatsApp style={{ color: "#25d366" }} />;
    default:
      return "error";
  }
};

const Connections = () => {
  const classes = useStyles();

  const { whatsApps, loading } = useContext(WhatsAppsContext);
  const [whatsAppModalOpen, setWhatsAppModalOpen] = useState(false);
  const [metaCloudModalOpen, setMetaCloudModalOpen] = useState(false);
  const [statusImport, setStatusImport] = useState([]);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [selectedWhatsApp, setSelectedWhatsApp] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const history = useHistory();
  const confirmationModalInitialState = {
    action: "",
    title: "",
    message: "",
    whatsAppId: "",
    open: false,
  };
  const [confirmModalInfo, setConfirmModalInfo] = useState(
    confirmationModalInitialState
  );
  const [planConfig, setPlanConfig] = useState(false);
  const [supportWhatsapp, setSupportWhatsapp] = useState("");
  const [connectionHealth, setConnectionHealth] = useState(null);
  const [openIncidents, setOpenIncidents] = useState([]);
  const [advancedOpen, setAdvancedOpen] = useState(false);

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const companyId = user.companyId;

  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const planConfigs = await getPlanCompany(undefined, companyId);
      setPlanConfig(planConfigs);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    let active = true;

    const loadConnectionQuality = async () => {
      try {
        const [healthResponse, incidentsResponse] = await Promise.all([
          api.get("/connection-health/company"),
          api.get("/connection-health/incidents/open"),
        ]);

        if (active) {
          setConnectionHealth(healthResponse.data);
          setOpenIncidents(incidentsResponse.data || []);
        }
      } catch (err) {
        console.error("Erro ao carregar qualidade das conexões:", err);
      }
    };

    loadConnectionQuality();
    const interval = setInterval(loadConnectionQuality, 15000);

    return () => {
      active = false;
      clearInterval(interval);
    };
  }, []);

  const responseFacebook = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, userID } = response;

      api
        .post("/facebook", {
          facebookUserId: userID,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t("connections.facebook.success"));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  const responseInstagram = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, userID } = response;

      api
        .post("/facebook", {
          addInstagram: true,
          facebookUserId: userID,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t("connections.facebook.success"));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  useEffect(() => {
    const onImportMessages = (data) => {
      if (data.action === "refresh") {
        setStatusImport([]);
        history.go(0);
      }
      if (data.action === "update") {
        setStatusImport(data.status);
      }
    };

    socket.on(`importMessages-${user.companyId}`, onImportMessages);

    return () => {
      socket.off(`importMessages-${user.companyId}`, onImportMessages);
    };
  }, [socket, user.companyId, history]);

  // Buscar WhatsApp de suporte (Whitelabel → fallback .env)
  useEffect(() => {
    const fetchSupportWhatsapp = async () => {
      try {
        const { data } = await api.get("/global-config/public-branding");

        const fromPanel = data?.loginWhatsapp;
        const fromEnv = process.env.REACT_APP_NUMBER_SUPPORT
          ? `https://wa.me/${process.env.REACT_APP_NUMBER_SUPPORT}`
          : "";

        setSupportWhatsapp(fromPanel || fromEnv);
      } catch (err) {
        console.error("Erro ao carregar número de suporte:", err);

        if (process.env.REACT_APP_NUMBER_SUPPORT) {
          setSupportWhatsapp(
            `https://wa.me/${process.env.REACT_APP_NUMBER_SUPPORT}`
          );
        }
      }
    };

    fetchSupportWhatsapp();
  }, []);

  const handleStartWhatsAppSession = async (whatsAppId) => {
    try {
      await api.post(`/whatsappsession/${whatsAppId}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleRequestNewQrCode = async (whatsAppId) => {
    try {
      await api.put(`/whatsappsession/${whatsAppId}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleQuickCreateWhatsApp = async () => {
    try {
      const { data } = await api.post(
        "/whatsapp/quick-create"
      );

      setSelectedWhatsApp(data);
      setQrModalOpen(true);

      toast.success(
        "Escaneie o QR Code para conectar o WhatsApp."
      );
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenMetaCloudModal = () => {
    setMetaCloudModalOpen(true);
  };

  const handleCloseMetaCloudModal = () => {
    setMetaCloudModalOpen(false);
  };

  const handleMetaCloudSuccess = () => {
    setMetaCloudModalOpen(false);
  };

  const handleCloseWhatsAppModal = useCallback(() => {
    setWhatsAppModalOpen(false);
    setSelectedWhatsApp(null);
  }, [setSelectedWhatsApp, setWhatsAppModalOpen]);

  const handleOpenQrModal = (whatsApp) => {
    setSelectedWhatsApp(whatsApp);
    setQrModalOpen(true);
  };

  const handleCloseQrModal = useCallback(() => {
    setSelectedWhatsApp(null);
    setQrModalOpen(false);
  }, [setQrModalOpen, setSelectedWhatsApp]);

  const handleEditWhatsApp = (whatsApp) => {
    setSelectedWhatsApp(whatsApp);
    setWhatsAppModalOpen(true);
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleOpenConfirmationModal = (action, whatsAppId) => {
    if (action === "disconnect") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.disconnectTitle"),
        message: i18n.t("connections.confirmationModal.disconnectMessage"),
        whatsAppId: whatsAppId,
      });
    }

    if (action === "delete") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.deleteTitle"),
        message: i18n.t("connections.confirmationModal.deleteMessage"),
        whatsAppId: whatsAppId,
      });
    }
    if (action === "closedImported") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.closedImportedTitle"),
        message: i18n.t("connections.confirmationModal.closedImportedMessage"),
        whatsAppId: whatsAppId,
      });
    }
    setConfirmModalOpen(true);
  };

  const handleSubmitConfirmationModal = async () => {
    if (confirmModalInfo.action === "disconnect") {
      try {
        await api.delete(`/whatsappsession/${confirmModalInfo.whatsAppId}`);
      } catch (err) {
        toastError(err);
      }
    }

    if (confirmModalInfo.action === "delete") {
      try {
        await api.delete(`/whatsapp/${confirmModalInfo.whatsAppId}`);
        const [healthResponse, incidentsResponse] = await Promise.all([
          api.get("/connection-health/company"),
          api.get("/connection-health/incidents/open"),
        ]);
        setConnectionHealth(healthResponse.data);
        setOpenIncidents(incidentsResponse.data || []);
        toast.success(i18n.t("connections.toasts.deleted"));
      } catch (err) {
        toastError(err);
      }
    }
    if (confirmModalInfo.action === "closedImported") {
      try {
        await api.post(`/closedimported/${confirmModalInfo.whatsAppId}`);
        toast.success(i18n.t("connections.toasts.closedimported"));
      } catch (err) {
        toastError(err);
      }
    }

    setConfirmModalInfo(confirmationModalInitialState);
  };

  const renderImportButton = (whatsApp) => {
    if (whatsApp?.statusImportMessages === "renderButtonCloseTickets") {
      return (
        <Button
          style={{ marginLeft: 12 }}
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => {
            handleOpenConfirmationModal("closedImported", whatsApp.id);
          }}
        >
          {i18n.t("connections.buttons.closedImported")}
        </Button>
      );
    }

    if (whatsApp?.importOldMessages) {
      let isTimeStamp = !isNaN(
        new Date(Math.floor(whatsApp?.statusImportMessages)).getTime()
      );

      if (isTimeStamp) {
        const ultimoStatus = new Date(
          Math.floor(whatsApp?.statusImportMessages)
        ).getTime();
        const dataLimite = +add(ultimoStatus, { seconds: +35 }).getTime();
        if (dataLimite > new Date().getTime()) {
          return (
            <>
              <Button
                disabled
                style={{ marginLeft: 12 }}
                size="small"
                endIcon={
                  <CircularProgress
                    size={12}
                    className={classes.buttonProgress}
                  />
                }
                variant="outlined"
                color="primary"
              >
                {i18n.t("connections.buttons.preparing")}
              </Button>
            </>
          );
        }
      }
    }
  };

  const renderActionButtons = (whatsApp) => {
    return (
      <>
        {whatsApp.status === "qrcode" && (
          <Can
            role={
              user.profile === "user" && user.allowConnections === "enabled"
                ? "admin"
                : user.profile
            }
            perform="connections-page:addConnection"
            yes={() => (
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={() => handleOpenQrModal(whatsApp)}
              >
                {i18n.t("connections.buttons.qrcode")}
              </Button>
            )}
          />
        )}
        {whatsApp.status === "DISCONNECTED" && (
          <Can
            role={
              user.profile === "user" && user.allowConnections === "enabled"
                ? "admin"
                : user.profile
            }
            perform="connections-page:addConnection"
            yes={() => (
              <>
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={() => handleStartWhatsAppSession(whatsApp.id)}
                >
                  {i18n.t("connections.buttons.tryAgain")}
                </Button>{" "}
                <Button
                  size="small"
                  variant="outlined"
                  color="secondary"
                  onClick={() => handleRequestNewQrCode(whatsApp.id)}
                >
                  {i18n.t("connections.buttons.newQr")}
                </Button>
              </>
            )}
          />
        )}
        {(whatsApp.status === "CONNECTED" ||
          whatsApp.status === "PAIRING" ||
          whatsApp.status === "TIMEOUT") && (
          <Can
            role={user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <>
                <Button
                  size="small"
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    handleOpenConfirmationModal("disconnect", whatsApp.id);
                  }}
                >
                  {i18n.t("connections.buttons.disconnect")}
                </Button>

                {renderImportButton(whatsApp)}
              </>
            )}
          />
        )}
        {whatsApp.status === "OPENING" && (
          <Button size="small" variant="outlined" disabled color="default">
            {i18n.t("connections.buttons.connecting")}
          </Button>
        )}
      </>
    );
  };

  const renderStatusToolTips = (whatsApp) => {
    return (
      <div className={classes.customTableCell}>
        {whatsApp.status === "DISCONNECTED" && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.disconnected.title")}
            content={i18n.t("connections.toolTips.disconnected.content")}
          >
            <SignalCellularConnectedNoInternet0Bar color="secondary" />
          </CustomToolTip>
        )}
        {whatsApp.status === "OPENING" && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
        {whatsApp.status === "qrcode" && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.qrcode.title")}
            content={i18n.t("connections.toolTips.qrcode.content")}
          >
            <CropFree />
          </CustomToolTip>
        )}
        {whatsApp.status === "CONNECTED" && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.connected.title")}
          >
            <SignalCellular4Bar style={{ color: green[500] }} />
          </CustomToolTip>
        )}
        {(whatsApp.status === "TIMEOUT" || whatsApp.status === "PAIRING") && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.timeout.title")}
            content={i18n.t("connections.toolTips.timeout.content")}
          >
            <SignalCellularConnectedNoInternet2Bar color="secondary" />
          </CustomToolTip>
        )}
      </div>
    );
  };


  const primaryWhatsapp =
    whatsApps.find(w => w.isDefault) ||
    whatsApps[0];

  const connectionLimit =
    Number(
      planConfig?.plan?.connections ||
      0
    );

  const connectionsInUse =
    whatsApps.filter(
      item =>
        item.channel === "whatsapp"
    ).length;

  const canAddAnotherWhatsapp =
    connectionLimit <= 0 ||
    connectionsInUse < connectionLimit;

  const handleQuickConnect = async () => {
    try {
      let whatsapp = primaryWhatsapp;

      if (!whatsapp) {
        const { data } = await api.post(
          "/whatsapp/onboarding"
        );

        whatsapp = data;
      } else if (
        whatsapp.status !== "qrcode" &&
        whatsapp.status !== "CONNECTED"
      ) {
        await api.put(
          `/whatsappsession/${whatsapp.id}`
        );
      }

      if (!whatsapp?.id) {
        throw new Error(
          "Não foi possível identificar a conexão."
        );
      }

      setSelectedWhatsApp(whatsapp);
      setQrModalOpen(true);
    } catch (error) {
      toastError(error);
    }
  };

  const handleQuickNewQr = async () => {
    try {
      if (!primaryWhatsapp?.id) {
        await handleQuickConnect();
        return;
      }

      await api.put(
        `/whatsappsession/${primaryWhatsapp.id}`
      );

      setSelectedWhatsApp(primaryWhatsapp);
      setQrModalOpen(true);

      toast.info(
        "Novo QR Code solicitado. Aguarde alguns segundos."
      );
    } catch (error) {
      toastError(error);
    }
  };

  const restartWhatsapps = async () => {
    try {
      await api.post(`/whatsapp-restart/`);
      toast.success(i18n.t("connections.waitConnection"));
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <div className={classes.pageRoot}>
      <ConfirmationModal
        title={confirmModalInfo.title}
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={handleSubmitConfirmationModal}
      >
        {confirmModalInfo.message}
      </ConfirmationModal>
      {qrModalOpen && (
        <QrcodeModal
          open={qrModalOpen}
          onClose={handleCloseQrModal}
          whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
        />
      )}
      <WhatsAppModal
        open={whatsAppModalOpen}
        onClose={handleCloseWhatsAppModal}
        whatsAppId={!qrModalOpen && selectedWhatsApp?.id}
      />

      <MetaCloudModal
        open={metaCloudModalOpen}
        onClose={handleCloseMetaCloudModal}
        onSuccess={handleMetaCloudSuccess}
      />
      {user.profile === "user" && user.allowConnections === "disabled" ? (
        <ForbiddenPage />
      ) : (
        <>
          <div className={classes.pageHeader}>
            <div className={classes.heroBg} />
            <div className={classes.heroLeft}>
              <div className={classes.heroIcon}>📱</div>
              <div>
                <Typography className={classes.heroTitle}>Conexões WhatsApp</Typography>
                <Typography className={classes.heroSub}>
                  Conecte seus números e gerencie as sessões ativas
                </Typography>
              </div>
            </div>
            <div className={classes.heroRight}>
              <Chip
                className={classes.headerChip}
                size="small"
                label={`${whatsApps.filter(w => w.status === "CONNECTED").length} online`}
                style={{ color: "#25D366", borderColor: "rgba(37,211,102,0.3)", background: "rgba(37,211,102,0.08)" }}
              />
              <Chip
                className={classes.headerChip}
                size="small"
                label={`${whatsApps.length} total`}
              />
              <Can
                role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
                perform="connections-page:addConnection"
                yes={() => (
                  <Button
                    style={{ display: "none" }}
                    className={classes.addWaBtn}
                    variant="contained"
                    startIcon={<WhatsApp style={{ fontSize: 18 }} />}
                    onClick={handleQuickCreateWhatsApp}
                  >
                    + Nova conexão
                  </Button>
                )}
              />
            </div>
          </div>

          <ConnectionMethodCards
            canAddAnotherWhatsapp={canAddAnotherWhatsapp}
            connectionLimit={connectionLimit}
            connectionsInUse={connectionsInUse}
            onConnectQrCode={handleQuickCreateWhatsApp}
            onConnectOfficial={handleOpenMetaCloudModal}
          />

          <ConnectionOverviewCard
            whatsapp={primaryWhatsapp}
            connectionHealth={connectionHealth}
            onConnect={handleQuickConnect}
            onReconnect={handleQuickNewQr}
            onNewQr={handleQuickNewQr}
            onAddFirstConnection={handleQuickConnect}
            onManage={() =>
              primaryWhatsapp &&
              handleEditWhatsApp(primaryWhatsapp)
            }
          />


          <Paper
            variant="outlined"
            style={{
              flexShrink: 0,
              padding: "12px 16px",
              borderRadius: 14,
              border: "1px solid rgba(15,23,42,.10)",
              boxShadow: "0 2px 8px rgba(15,23,42,.04)"
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              flexWrap="wrap"
              gridGap={12}
            >
              <Box>
                <Typography
                  style={{
                    fontWeight: 800,
                    fontSize: "0.86rem"
                  }}
                >
                  Configurações avançadas
                </Typography>

                <Typography
                  color="textSecondary"
                  style={{
                    marginTop: 2,
                    fontSize: "0.72rem"
                  }}
                >
                  Gerencie conexões adicionais, integrações e funções técnicas.
                </Typography>
              </Box>

              <Box
                display="flex"
                alignItems="center"
                flexWrap="wrap"
                gridGap={8}
              >
                <Can
                  role={
                    user.profile === "user" &&
                    user.allowConnections === "enabled"
                      ? "admin"
                      : user.profile
                  }
                  perform="connections-page:addConnection"
                  yes={() => (
                    <Button
                      variant="contained"
                      onClick={
                        canAddAnotherWhatsapp
                          ? handleQuickCreateWhatsApp
                          : undefined
                      }
                      disabled={!canAddAnotherWhatsapp}
                      style={{
                        minHeight: 38,
                        borderRadius: 10,
                        color: "#FFFFFF",
                        fontWeight: 800,
                        textTransform: "none",
                        background: canAddAnotherWhatsapp
                          ? "linear-gradient(135deg,#25D366,#128C7E)"
                          : "#94A3B8",
                        boxShadow: canAddAnotherWhatsapp
                          ? "0 4px 12px rgba(37,211,102,.22)"
                          : "none"
                      }}
                    >
                      {canAddAnotherWhatsapp
                        ? "+ Adicionar outro WhatsApp"
                        : "Limite do plano atingido"}
                    </Button>
                  )}
                />

                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() =>
                    setAdvancedOpen(current => !current)
                  }
                  style={{
                    minHeight: 38,
                    borderRadius: 10,
                    fontWeight: 800,
                    textTransform: "none"
                  }}
                >
                  {advancedOpen
                    ? "Ocultar configurações"
                    : "Abrir configurações"}
                </Button>
              </Box>
            </Box>
          </Paper>

          <Paper
            className={classes.controlsPaper}
            variant="outlined"
            style={{
              display: advancedOpen
                ? "block"
                : "none"
            }}
          >
            <Box
              display="flex"
              flexWrap="wrap"
              alignItems="center"
              justifyContent="space-between"
              gridGap={12}
              marginBottom={12}
            >
              <Box>
                <Typography style={{ fontWeight: 800, fontSize: "0.9rem" }}>
                  Central de qualidade da conexão
                </Typography>
                <Typography color="textSecondary" style={{ fontSize: "0.75rem" }}>
                  Monitoramento automático das sessões, reconexões e incidentes
                </Typography>
              </Box>

              <Box display="flex" flexWrap="wrap" gridGap={8}>
                <Chip
                  size="small"
                  label={`Saúde média: ${connectionHealth?.averageHealthScore ?? 0}%`}
                  color={
                    (connectionHealth?.averageHealthScore ?? 0) >= 80
                      ? "primary"
                      : "default"
                  }
                />
                <Chip
                  size="small"
                  label={`${connectionHealth?.connected ?? 0} conectadas`}
                  style={{
                    color: "#128C7E",
                    border: "1px solid rgba(37,211,102,0.35)",
                    background: "rgba(37,211,102,0.08)",
                  }}
                />
                <Chip
                  size="small"
                  label={`${connectionHealth?.reconnecting ?? 0} reconectando`}
                />
                <Chip
                  size="small"
                  label={`${connectionHealth?.requiresAttention ?? 0} precisam de atenção`}
                  color={
                    (connectionHealth?.requiresAttention ?? 0) > 0
                      ? "secondary"
                      : "default"
                  }
                />
                <Chip
                  size="small"
                  label={`${openIncidents.length} incidentes abertos`}
                  color={openIncidents.length > 0 ? "secondary" : "default"}
                />
              </Box>
            </Box>

            <div className={classes.controlsActions}>
              <Button
                className={classes.actionButton}
                variant="contained"
                color="primary"
                onClick={restartWhatsapps}
              >
                {i18n.t("connections.restartConnections")}
              </Button>

              <Button
                className={classes.actionButton}
                variant="contained"
                color="primary"
                onClick={() => openInNewTab(supportWhatsapp)}
              >
                {i18n.t("connections.callSupport")}
              </Button>
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <Can
                      role={user.profile}
                      perform="connections-page:addConnection"
                      yes={() => (
                        <>
                          <Button
                            className={classes.actionButton}
                            variant="contained"
                            color="primary"
                            {...bindTrigger(popupState)}
                          >
                            {i18n.t("connections.newConnection")}
                          </Button>
                          <Menu {...bindMenu(popupState)}>
                            {/* WHATSAPP */}
                            <MenuItem
                              disabled={
                                planConfig?.plan?.useWhatsapp ? false : true
                              }
                              onClick={() => {
                                handleQuickCreateWhatsApp();
                                popupState.close();
                              }}
                            >
                              <WhatsApp
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#25D366",
                                }}
                              />
                              WhatsApp
                            </MenuItem>
                            {/* FACEBOOK */}
                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              version="9.0"
                              scope={
                                process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() ===
                                "TRUE"
                                  ? "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement,business_management"
                                  : "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement"
                              }
                              callback={responseFacebook}
                              render={(renderProps) => (
                                <MenuItem
                                  disabled={
                                    planConfig?.plan?.useFacebook
                                      ? false
                                      : true
                                  }
                                  onClick={renderProps.onClick}
                                >
                                  <Facebook
                                    fontSize="small"
                                    style={{
                                      marginRight: "10px",
                                      color: "#3b5998",
                                    }}
                                  />
                                  Facebook
                                </MenuItem>
                              )}
                            />
                            {/* INSTAGRAM */}
                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              version="9.0"
                              scope={
                                process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() ===
                                "TRUE"
                                  ? "public_profile,instagram_basic,instagram_manage_messages,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement,business_management"
                                  : "public_profile,instagram_basic,instagram_manage_messages,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement"
                              }
                              callback={responseInstagram}
                              render={(renderProps) => (
                                <MenuItem
                                  disabled={
                                    planConfig?.plan?.useInstagram
                                      ? false
                                      : true
                                  }
                                  onClick={renderProps.onClick}
                                >
                                  <Instagram
                                    fontSize="small"
                                    style={{
                                      marginRight: "10px",
                                      color: "#e1306c",
                                    }}
                                  />
                                  Instagram
                                </MenuItem>
                              )}
                            />
                          </Menu>
                        </>
                      )}
                    />
                  </React.Fragment>
                )}
              </PopupState>
            </div>
          </Paper>

          {advancedOpen && statusImport?.all ? (
            <>
              <div>
                <Card className={classes.statusCard}>
                  <CardContent className={classes.statusCardContent}>
                    <Typography className={classes.statusTitle}>
                      {statusImport?.this === -1
                        ? i18n.t("connections.buttons.preparing")
                        : i18n.t("connections.buttons.importing")}
                    </Typography>
                    {statusImport?.this === -1 ? (
                      <Typography className={classes.statusText} align="center">
                        <CircularProgress size={24} />
                      </Typography>
                    ) : (
                      <>
                        <Typography className={classes.statusText} align="center">
                          {`${i18n.t(
                            `connections.typography.processed`
                          )} ${statusImport?.this} ${i18n.t(
                            `connections.typography.in`
                          )} ${statusImport?.all}  ${i18n.t(
                            `connections.typography.date`
                          )}: ${statusImport?.date} `}
                        </Typography>
                        <Typography align="center">
                          <CircularProgressWithLabel
                            style={{ margin: "auto" }}
                            value={
                              (statusImport?.this / statusImport?.all) * 100
                            }
                          />
                        </Typography>
                      </>
                    )}
                  </CardContent>
                </Card>
              </div>
            </>
          ) : null}

          <Paper
            className={classes.mainPaper}
            variant="outlined"
            style={{
              display: advancedOpen
                ? "block"
                : "none"
            }}
          >
            <div className={classes.desktopConnectionsTable}>
              <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeaderCell} align="center">
                    Channel
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell} align="center">
                    {i18n.t("connections.table.name")}
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell} align="center">
                    {i18n.t("connections.table.number")}
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell} align="center">
                    {i18n.t("connections.table.status")}
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell} align="center">
                    Qualidade
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell} align="center">
                    {i18n.t("connections.table.session")}
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell} align="center">
                    {i18n.t("connections.table.lastUpdate")}
                  </TableCell>
                  <TableCell className={classes.tableHeaderCell} align="center">
                    {i18n.t("connections.table.default")}
                  </TableCell>
                  <Can
                    role={
                      user.profile === "user" &&
                      user.allowConnections === "enabled"
                        ? "admin"
                        : user.profile
                    }
                    perform="connections-page:addConnection"
                    yes={() => (
                      <TableCell className={classes.tableHeaderCell} align="center">
                        {i18n.t("connections.table.actions")}
                      </TableCell>
                    )}
                  />
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRowSkeleton />
                ) : (
                  <>
                    {whatsApps?.length > 0 &&
                      whatsApps.map((whatsApp) => (
                        <TableRow key={whatsApp.id}>
                          <TableCell align="center">
                            {IconChannel(whatsApp.channel)}
                          </TableCell>
                          <TableCell className={classes.tableCellText} align="center">
                            {whatsApp.name}
                          </TableCell>
                          <TableCell className={classes.tableCellText} align="center">
                            {whatsApp.number &&
                            whatsApp.channel === "whatsapp" ? (
                              <>{formatSerializedId(whatsApp.number)}</>
                            ) : (
                              whatsApp.number
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {renderStatusToolTips(whatsApp)}
                          </TableCell>
                          <TableCell align="center">
                            {(() => {
                              const health = connectionHealth?.connections?.find(
                                item => Number(item.connectionId) === Number(whatsApp.id)
                              );

                              if (!health) {
                                return (
                                  <Chip
                                    size="small"
                                    label="Aguardando dados"
                                    variant="outlined"
                                  />
                                );
                              }

                              const healthLabels = {
                                HEALTHY: "Saudável",
                                WARNING: "Atenção",
                                CRITICAL: "Crítica",
                                OFFLINE: "Offline",
                              };

                              return (
                                <Tooltip
                                  title={`Status: ${health.status} • Reconexões: ${health.reconnectAttempts}`}
                                >
                                  <Chip
                                    size="small"
                                    label={`${healthLabels[health.healthLevel] || health.healthLevel} • ${health.healthScore}%`}
                                    style={{
                                      fontWeight: 700,
                                      color:
                                        health.healthLevel === "HEALTHY"
                                          ? "#128C7E"
                                          : health.healthLevel === "WARNING"
                                          ? "#B7791F"
                                          : "#D32F2F",
                                      background:
                                        health.healthLevel === "HEALTHY"
                                          ? "rgba(37,211,102,0.10)"
                                          : health.healthLevel === "WARNING"
                                          ? "rgba(245,158,11,0.12)"
                                          : "rgba(211,47,47,0.10)",
                                      border: "1px solid currentColor",
                                    }}
                                  />
                                </Tooltip>
                              );
                            })()}
                          </TableCell>
                          <TableCell align="center">
                            {renderActionButtons(whatsApp)}
                          </TableCell>
                          <TableCell className={classes.tableCellText} align="center">
                            {format(
                              parseISO(whatsApp.updatedAt),
                              "dd/MM/yy HH:mm"
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {whatsApp.isDefault && (
                              <div className={classes.customTableCell}>
                                <CheckCircle style={{ color: green[500] }} />
                              </div>
                            )}
                          </TableCell>
                          <Can
                            role={user.profile}
                            perform="connections-page:addConnection"
                            yes={() => (
                              <TableCell align="center">
                                <IconButton
                                  className={classes.actionIconButton}
                                  size="small"
                                  onClick={() =>
                                    handleEditWhatsApp(whatsApp)
                                  }
                                >
                                  <Edit />
                                </IconButton>

                                <IconButton
                                  className={classes.actionIconButton}
                                  size="small"
                                  onClick={(e) => {
                                    handleOpenConfirmationModal(
                                      "delete",
                                      whatsApp.id
                                    );
                                  }}
                                >
                                  <DeleteOutline />
                                </IconButton>
                              </TableCell>
                            )}
                          />
                        </TableRow>
                      ))}
                  </>
                )}
              </TableBody>
            </Table>
            </div>

            <div className={classes.mobileConnectionsList}>
              {loading ? (
                <div className={classes.emptyConnectionsMobile}>
                  Carregando conexões...
                </div>
              ) : (
                <>
                  {whatsApps?.map(whatsApp => {
                    const health = connectionHealth?.connections?.find(
                      item =>
                        Number(item.connectionId) === Number(whatsApp.id)
                    );

                    const healthLabels = {
                      HEALTHY: "Saudável",
                      WARNING: "Atenção",
                      CRITICAL: "Crítica",
                      OFFLINE: "Offline"
                    };

                    const formattedNumber =
                      whatsApp.number &&
                      whatsApp.channel === "whatsapp"
                        ? formatSerializedId(whatsApp.number)
                        : whatsApp.number || "Número não informado";

                    return (
                      <div
                        key={`mobile-connection-${whatsApp.id}`}
                        className={classes.connectionMobileCard}
                      >
                        <div className={classes.connectionMobileHeader}>
                          <div className={classes.connectionChannelIcon}>
                            {IconChannel(whatsApp.channel)}
                          </div>

                          <div className={classes.connectionIdentity}>
                            <Typography className={classes.connectionMobileName}>
                              {whatsApp.name || "Conexão sem nome"}
                            </Typography>

                            <Typography className={classes.connectionMobileNumber}>
                              {formattedNumber}
                            </Typography>
                          </div>

                          {whatsApp.isDefault && (
                            <div
                              className={classes.defaultBadge}
                              title="Conexão padrão"
                            >
                              <CheckCircle />
                            </div>
                          )}
                        </div>

                        <div className={classes.connectionMobileMeta}>
                          <div className={classes.connectionMetaBox}>
                            <div className={classes.connectionMetaLabel}>
                              Status
                            </div>

                            <div className={classes.connectionMetaValue}>
                              {renderStatusToolTips(whatsApp)}
                            </div>
                          </div>

                          <div className={classes.connectionMetaBox}>
                            <div className={classes.connectionMetaLabel}>
                              Qualidade
                            </div>

                            <div className={classes.connectionMetaValue}>
                              {health ? (
                                <Chip
                                  size="small"
                                  label={`${
                                    healthLabels[health.healthLevel] ||
                                    health.healthLevel
                                  } • ${health.healthScore}%`}
                                  style={{
                                    maxWidth: "100%",
                                    height: 24,
                                    fontSize: ".63rem",
                                    fontWeight: 750,
                                    color:
                                      health.healthLevel === "HEALTHY"
                                        ? "#128C7E"
                                        : health.healthLevel === "WARNING"
                                        ? "#B7791F"
                                        : "#D32F2F",
                                    background:
                                      health.healthLevel === "HEALTHY"
                                        ? "rgba(37,211,102,.10)"
                                        : health.healthLevel === "WARNING"
                                        ? "rgba(245,158,11,.12)"
                                        : "rgba(211,47,47,.10)",
                                    border: "1px solid currentColor"
                                  }}
                                />
                              ) : (
                                <Chip
                                  size="small"
                                  label="Aguardando dados"
                                  variant="outlined"
                                  style={{
                                    maxWidth: "100%",
                                    height: 24,
                                    fontSize: ".62rem"
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>

                        <div className={classes.connectionMobileSession}>
                          <div className={classes.connectionMetaLabel}>
                            Sessão e conexão
                          </div>

                          <div
                            style={{
                              marginTop: 7,
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 7
                            }}
                          >
                            {renderActionButtons(whatsApp)}
                          </div>
                        </div>

                        <div className={classes.connectionMobileFooter}>
                          <span className={classes.connectionUpdatedAt}>
                            Atualizada em{" "}
                            {format(
                              parseISO(whatsApp.updatedAt),
                              "dd/MM/yy HH:mm"
                            )}
                          </span>

                          <Can
                            role={user.profile}
                            perform="connections-page:addConnection"
                            yes={() => (
                              <div className={classes.connectionCardActions}>
                                <IconButton
                                  className={`${classes.connectionCardAction} ${classes.editConnectionAction}`}
                                  onClick={() => handleEditWhatsApp(whatsApp)}
                                  aria-label={`Editar ${whatsApp.name}`}
                                >
                                  <Edit />
                                </IconButton>

                                <IconButton
                                  className={`${classes.connectionCardAction} ${classes.deleteConnectionAction}`}
                                  onClick={() =>
                                    handleOpenConfirmationModal(
                                      "delete",
                                      whatsApp.id
                                    )
                                  }
                                  aria-label={`Excluir ${whatsApp.name}`}
                                >
                                  <DeleteOutline />
                                </IconButton>
                              </div>
                            )}
                          />
                        </div>
                      </div>
                    );
                  })}

                  {(!whatsApps || whatsApps.length === 0) && (
                    <div className={classes.emptyConnectionsMobile}>
                      Nenhuma conexão cadastrada.
                    </div>
                  )}
                </>
              )}
            </div>
          </Paper>
        </>
      )}
    </div>
  );
};

export default Connections;
